@if (editColumnForm) {
  <div class="board-column-edit" [formGroup]="editColumnForm">
    <div class="form-group">
      <app-input
        [formControl]="editColumnForm.controls.name"
        label="{{ 'name_column' | translate }}"
        placeholder="{{ 'name_column' | translate }}"
      />
    </div>

    @if (canEditType) {
      <div class="flex flex-col gap-1">
        <app-select
          [formControl]="editColumnForm.controls.type"
          [options]="columnTypeOptions"
          [optionLabel]="'name'"
          [optionValue]="'value'"
          [isTranslate]="true"
          [label]="'board_v3_column_type'"
          [placeholder]="'board_v3_column_type' | translate"
        />
      </div>
    }

    <div class="color-inputs">
      <div class="form-group">
        <label class="form-label" for="columnBgColor">{{ 'column_color' | translate }}</label>
        <input id="columnBgColor" class="form-control form-control-color" type="color" formControlName="bg_color" />
      </div>

      <div class="form-group">
        <label class="form-label" for="columnTextColor">{{ 'name_color' | translate }}</label>
        <input id="columnTextColor" class="form-control form-control-color" type="color" formControlName="text_color" />
      </div>
    </div>

    <div class="d-flex justify-content-end gap-2 mt-3">
      <app-button [btnType]="'cancel'" (onChangeClick)="onCancel()">
        {{ 'cancel' | translate }}
      </app-button>
      <app-button (onChangeClick)="onSave()" [disabled]="editColumnForm.invalid || !hasChanges">
        {{ 'save' | translate }}
      </app-button>
    </div>
  </div>
}
